import { GroupColumnDef } from "@tanstack/react-table";
import { ReactNode } from "react";
import classNames from "classnames";

export type TableHeaderProps<T> =
  Partial<Omit<GroupColumnDef<T>, "columns" | "cell" | "header">>
  & {
  className?: string;
  header: string;
  children?: ReactNode;
  align?: "left" | "center" | "right";
  overflow?: "ellipsis" | "clip";
}

export const TableHeader = <T,>({
  className,
  header
}: TableHeaderProps<T>) => {
  return (
    <span className={classNames(className)}>{header}</span>
  );
};
